import { Select, SelectProps } from "antd";
import { ComponentType, CSSProperties } from "react";
import styled, { css } from "styled-components";

type SelectorStyleProps = {
  $height?: CSSProperties["height"];
  $fontSize?: CSSProperties["fontSize"];
};

const toCssSize = (
  value?: CSSProperties["height"] | CSSProperties["fontSize"],
) => {
  if (value === undefined) return undefined;

  return typeof value === "number" ? `${value}px` : value;
};

const SelectForStyling = Select as ComponentType<SelectProps<any>>;

export const StyledSelect = styled(SelectForStyling)<SelectorStyleProps>`
  ${({ $height }) =>
    $height !== undefined &&
    css`
      height: ${toCssSize($height)} !important;
      min-height: ${toCssSize($height)} !important;
      .ant-select-selector {
        height: 100% !important;
        min-height: 100% !important;
        display: flex !important;
        align-items: center !important;
      }

      .ant-select-selection-search {
        display: flex;
        align-items: center;
      }

      .ant-select-selection-search-input {
        height: 100% !important;
      }
    `}

  ${({ $fontSize }) =>
    $fontSize !== undefined &&
    css`
      .ant-select-selector,
      .ant-select-selection-item,
      .ant-select-selection-placeholder,
      .ant-select-selection-search-input {
        font-size: ${toCssSize($fontSize)} !important;
      }
    `}
`;
